import { render, staticRenderFns } from "./MainDialog.vue?vue&type=template&id=24bf1e16&"
import script from "./MainDialog.vue?vue&type=script&lang=js&"
export * from "./MainDialog.vue?vue&type=script&lang=js&"
import style0 from "./MainDialog.vue?vue&type=style&index=0&id=24bf1e16&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports